import Vue from 'vue';
import VueProgressBar from 'vue-progressbar';

const options = {
  color: '#bfd50c',
  thickness: '5px',
};

Vue.use(VueProgressBar, options);
